import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

function CreateUserPlan() {
  const [planID, setPlanId] = useState();
  const [visible, setVisible] = useState(false);
  
  axios.defaults.withCredentials = true;
  useEffect(() => {
    setTimeout(() => {
      setVisible(true);
    }, 100);
  }, []);

  const handleChange = (event) => {
    setPlanId(event.target.value);
  };

  const handleSubmit = () => {
    if (planID === undefined || planID === "") {
      alert("Please give your plan a title");
      return;
    }

    axios.post(process.env.REACT_APP_Apiurl +"user/createplan", {title:planID}).then((res) => {
        setPlanId(res.data.message);
      window.location.href = process.env.REACT_APP_App_Url + "planner/" + res.data.message;
    });
    
  };

  return (
    <div
      className={`flex items-center justify-center h-screen bg-[#121212] text-white `}
    >
      <div
        className={` transition-opacity duration-1000 ${
          visible ? "opacity-100" : "opacity-0"
        } bg-[#121212] text-left flex items-center`}
      >
        <div className={`relative bg-inherit`}>
          <input
            type="text"
            id="username"
            name="username"
            className="peer bg-transparent h-10 w-72 rounded-lg text-gray-200 placeholder-transparent ring-2 px-2 ring-gray-500 focus:ring-[#FFD700] focus:outline-none focus:border-rose-600"
            placeholder="Course Plan ID"
            onChange={handleChange}
          />
          <label
            htmlFor="username"
            className="absolute cursor-text left-0 -top-3 text-sm text-gray-500 bg-inherit mx-1 px-1 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-500 peer-placeholder-shown:top-2 peer-focus:-top-3 peer-focus:text-[#FFD700] peer-focus:text-sm transition-all"
          >
            Course Plan Title
          </label>
        </div>
        <button
          onClick={handleSubmit}
          className={` transition-opacity duration-500 ${
            visible ? "opacity-100" : "opacity-0"
          } relative inline-flex items-center justify-center m-4 p-4 px-3 py-2 overflow-hidden font-medium text-[#FFD700] transition duration-300 ease-out border-2 border-[#FFD700] rounded-lg shadow-md group`}
        >
          <span className="absolute inset-0 flex items-center justify-center w-full h-full text-white duration-300 -translate-x-full  group-hover:translate-x-0 ease">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              ></path>
            </svg>
          </span>
          <span className="absolute flex items-center justify-center w-full h-full text-[#FFD700] transition-all duration-300 transform group-hover:translate-x-full ease">
            Create
          </span>
          <span className="relative invisible">Button Text</span>
        </button>
      </div>
    </div>
  );
}

export default CreateUserPlan;
